import { createFileRoute } from '@tanstack/react-router';
import ZipBlastsListPage from '../../views/dashboard-zip-blasts';

export const Route = createFileRoute('/dashboard/zip-blasts/')({
  component: ZipBlastsListPage,
});
